import { connect } from 'react-redux';

import { loadUsersCareGuide } from '../../../../../state/modules/users/actions';
import UserCareGuideInput from '../components/UserCareGuideInput';

const mapStateToProps = (state) => {
  return {
    total: state.users.get('total'),
    isLoading: state.users.get('isLoading'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    load: (careGuideId, page, limit, order, filter, cb) => {
      dispatch(loadUsersCareGuide(careGuideId, page, limit, order, filter, cb));
    },
  };
};

const UserCareGuideInputContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCareGuideInput);

export default UserCareGuideInputContainer;
